import { MEMBER_EXPORTS_LOCKED, MEMBER_EXPORT_BYPASS_ROLES } from '../constants/dataUsePolicy';
import { useUserRole } from '../contexts/UserRoleContext';

/**
 * Conference-safe export lock for public users. Local government admins and super admins
 * retain CSV/PNG exports, customizable data tables, and the header Download Data modal.
 */
export function useMemberExportsLocked(): boolean {
  const { hasAnyRole } = useUserRole();
  if (!MEMBER_EXPORTS_LOCKED) return false;
  if (hasAnyRole([...MEMBER_EXPORT_BYPASS_ROLES])) return false;
  return true;
}
